const React = require("react");

const FileIcon = React.createClass({
    render() {
        return (<span className="glyphicon glyphicon-file" style={this.props.style}></span>);
    }
});

module.exports = FileIcon;


// WEBPACK FOOTER //
// ./src/components/FileIcon.jsx